import { PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS } from 'stash/actions/api';
import { BOOTSTRAP_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS } from 'stash/store/bootstrapActions';

type OnboardingAnswerEntry = {
	answers: string[];
};

type OnboardingAnswersState = Record<string, OnboardingAnswerEntry>;

type QuestionPatchItem = {
	questionKey: string;
	answerKeys: string[];
};

type OnboardingAnswersAction =
	| {
			type: typeof BOOTSTRAP_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS;
			response: { questions: OnboardingAnswersState };
	  }
	| {
			type: typeof PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS;
			request: { body: { data: QuestionPatchItem[] } };
	  }
	| { type: string };

const onboarding_answers = (
	state: OnboardingAnswersState = {},
	action: OnboardingAnswersAction
): OnboardingAnswersState => {
	switch (action.type) {
		case BOOTSTRAP_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS: {
			const a = action as Extract<
				OnboardingAnswersAction,
				{ type: typeof BOOTSTRAP_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS }
			>;
			return {
				...state,
				...a.response.questions,
			};
		}

		case PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS: {
			const a = action as Extract<
				OnboardingAnswersAction,
				{ type: typeof PATCH_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS }
			>;
			const questions = a.request.body.data.reduce<OnboardingAnswersState>((acc, question) => {
				return {
					...acc,
					[question.questionKey]: {
						answers: question.answerKeys,
					},
				};
			}, {});

			return {
				...state,
				...questions,
			};
		}

		default:
			return state;
	}
};

export default onboarding_answers;
